import { personName } from './names';

/** One row of GET /api/school/teachers/ — `profile_id` is what assignments reference. */
export interface TeacherProfile {
  profile_id: number;
  user_id: number;
  username: string;
  first_name: string;
  last_name: string;
}

/** "First Last" trimmed, falling back to the username. */
export const teacherName = (t: Pick<TeacherProfile, 'username' | 'first_name' | 'last_name'>): string =>
  personName(t);
